import { render, staticRenderFns } from "./commonImportModal.vue?vue&type=template&id=c0635492&scoped=true"
import script from "./commonImportModal.vue?vue&type=script&lang=js"
export * from "./commonImportModal.vue?vue&type=script&lang=js"
import style0 from "./commonImportModal.vue?vue&type=style&index=0&id=c0635492&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0635492",
  null
  
)

export default component.exports